<template>
  <div>
    <h2>O aplikaci</h2>
    <p>
      Server provozuje: Ústav zdravotnických informací a statistiky ČR -
      <a href="https://www.uzis.cz/" target="_blank">ÚZIS ČR</a>
    </p>
    <div class="contributors">
      <img
        src="@/assets/mzcr.gif"
        alt="Logo Ministerstva zdravotnictví ČR"
        title="Ministerstvo zdravotnictví ČR"
      />
      <img
        src="@/assets/uzis_logo.png"
        alt="Logo ÚZIS ČR"
        title="Ústav zdravotnických informací a statistiky ČR"
      />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$emit("caption", "O aplikaci");
  }
};
</script>

<style scoped>
.contributors {
  margin-top: 4em;
  padding: 1.5em;
  padding-bottom: 0;
}

.contributors img {
  display: block;
  width: 100%;
  margin-bottom: 1.5em;
}
</style>
